var ProductRecommendationsComponent = Vue.component('product-recommendations', {
    props: ['productId'],
    data: function () {
        return {
            accessories: [],
            spares: [],
            loaded: false
        };
    },
    created: function() {
        this.fetch('post', 'rshop-api/products/recommendations', { product_id: this.productId }, function (response) {
            if (response.result) {
                this.accessories = response.result.accessories ? response.result.accessories : [];
                this.spares = response.result.spares ? response.result.spares : [];
            }
            this.loaded = true;

            rEvent.dispatch('ProductRecommendations.loaded');
        }.bind(this));
    },
    computed: {
        empty: function() {
            return this.accessories.length == 0 && this.spares.length == 0;
        },
        emptyAccessories: function() {
            return this.accessories.length == 0;
        },
        emptySpares: function() {
            return this.spares.length == 0;
        }
    }
});